import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  id: "kt_modal_add_event_close",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body flex-center" }
const _hoisted_8 = { class: "row w-100" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "fv-row mb-5 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_11 = { class: "fs-6 fw-semibold mb-2 required" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "col"
}
const _hoisted_14 = { class: "fv-row mb-5" }
const _hoisted_15 = { class: "fs-6 fw-semibold mb-2" }
const _hoisted_16 = { class: "row w-100" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "fv-row mb-5 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_19 = { class: "fs-6 fw-semibold mb-2 required" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "col"
}
const _hoisted_22 = { class: "fv-row mb-5" }
const _hoisted_23 = { class: "fs-6 fw-semibold mb-2" }
const _hoisted_24 = { class: "modal-footer flex-center" }
const _hoisted_25 = {
  "data-bs-dismiss": "modal",
  type: "reset",
  id: "kt_modal_add_event_cancel",
  class: "btn btn-light me-3"
}
const _hoisted_26 = ["data-kt-indicator"]
const _hoisted_27 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_28 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_29 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import { ref, reactive, watch } from "vue";
import { TopicTypes } from "@/core/types/TopicTypes";
import GlobalService from "@/projects/tenant/modules/topic/services/TopicService";
import type { FormRules } from "element-plus";
import { hideModal, showModal } from "@/core/helpers/dom";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateNotice',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(true);
const submited = ref(false);
const createNoticeModalRef = ref<null | HTMLElement>(null);


const allDay = ref<boolean>(false);
const startDate = ref<any>(new Date());
const startTime = ref<any>(new Date());
const endDate = ref<any>(new Date());
const endTime = ref<any>(new Date());

const concatDates = (d1: Date, d2: Date) => {
  if (!d1 || !d2) return "";
  return allDay.value
    ? new Date(d1.getFullYear(), d1.getMonth(), d1.getDate(), 0, 0, 0)
    : new Date(
        d1?.getFullYear(),
        d1?.getMonth(),
        d1?.getDate(),
        d2?.getHours(),
        d2?.getMinutes(),
        d2?.getSeconds()
      );
};

const detailForm = ref<any>({
  title: "",
  type: TopicTypes.Notice,
  language: "en-us",
  content: "content",
  author: "system",
  effectiveFrom: concatDates(startDate.value, startTime.value),
  effectiveTo: concatDates(endDate.value, endTime.value),
});

const noticeFormRules = reactive<FormRules>({
  title: [{ required: true, message: "Please input the Notice template key" }],
});

const createNotice = async () => {
  submited.value = true;
  await GlobalService.createNotice(detailForm.value);
  emits("eventSubmit");
  submited.value = false;
  hide();
};

watch(
  [startDate, startTime],
  ([startDate, startTime]) => {
    if (!allDay.value && (!startDate || !startTime)) {
      detailForm.value.effectiveFrom = null;
      return;
    }
    detailForm.value.effectiveFrom = concatDates(startDate, startTime);
  },
  { immediate: true }
);

watch(
  [endDate, endTime],
  ([endDate, endTime]) => {
    if (!allDay.value && (!endDate || !endTime)) {
      detailForm.value.effectiveTo = null;
      return;
    }
    detailForm.value.effectiveTo = concatDates(endDate, endTime);
  },
  { immediate: true }
);

const show = () => {
  showModal(createNoticeModalRef.value);
  isLoading.value = false;
};

const hide = () => {
  hideModal(createNoticeModalRef.value);
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    role: "dialog",
    ref_key: "createNoticeModalRef",
    ref: createNoticeModalRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          class: "form fv-plugins-bootstrap5 fv-plugins-framework",
          id: "kt_modal_add_event_form",
          onSubmit: _withModifiers(createNotice, ["prevent"]),
          model: detailForm.value,
          rules: noticeFormRules,
          ref: "ruleFormRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.addNewTopic")), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.title'),
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: detailForm.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((detailForm.value.title) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, { prop: "effectiveFrom" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("title.eventStartDate")), 1),
                        _createVNode(_component_el_date_picker, {
                          modelValue: startDate.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event)),
                          type: "date",
                          teleported: false,
                          name: "eventStartDate"
                        }, null, 8, ["modelValue"]),
                        _hoisted_12
                      ])
                    ]),
                    (!allDay.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("title.eventStartTime")), 1),
                            _createVNode(_component_el_time_picker, {
                              modelValue: startTime.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startTime).value = $event)),
                              "arrow-control": "",
                              teleported: false,
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "effectiveTo" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("title.eventEndDate")), 1),
                        _createVNode(_component_el_date_picker, {
                          modelValue: endDate.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endDate).value = $event)),
                          type: "date",
                          teleported: false,
                          name: "eventName"
                        }, null, 8, ["modelValue"]),
                        _hoisted_20
                      ])
                    ]),
                    (!allDay.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("title.eventEndTime")), 1),
                            _createVNode(_component_el_time_picker, {
                              modelValue: endTime.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((endTime).value = $event)),
                              teleported: false,
                              "arrow-control": "",
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", _hoisted_25, _toDisplayString(_ctx.$t("status.cancel")), 1),
              _createElementVNode("button", {
                "data-kt-indicator": isLoading.value ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit"
              }, [
                (!isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.submit")) + " ", 1),
                      _createElementVNode("span", _hoisted_28, [
                        _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                      _createTextVNode(_toDisplayString(_ctx.$t("title.inProgress")) + " ", 1),
                      _hoisted_30
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_26)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "model", "rules"])
      ])
    ])
  ], 512))
}
}

})